export const defaultFamily = {
    familyName: '',
    customerId: null,
    comments: '',
}
